// Color launch landing page (sections/nr-color-launch.liquid): pack picker + add to cart without
// leaving the page. Respects the 8" single cap (assets/nr-qty-cap.js) when it's loaded.
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const selected = (card) => card.querySelector('.nrcl-pack[aria-checked="true"]');

  function select(card, pack) {
    if (pack.getAttribute('aria-disabled') === 'true') return;
    card.querySelectorAll('.nrcl-pack').forEach((p) => p.setAttribute('aria-checked', String(p === pack)));
    const price = card.querySelector('[data-price]');
    const unit = card.querySelector('[data-unit]');
    if (price) price.textContent = pack.dataset.price;
    if (unit) unit.textContent = pack.dataset.unit || '';
    // Kit cards: show the photo for the selected kit (1-pack vs 2-pack).
    const photo = card.querySelector('.nrcl-kit__media img');
    if (photo && pack.dataset.img) {
      photo.src = pack.dataset.img;
      photo.srcset = pack.dataset.imgSrcset || '';
    }
    const add = card.querySelector('[data-add]');
    const available = pack.dataset.available === 'true';
    add.disabled = !available;
    add.querySelector('[data-add-label]').textContent = available ? 'Add to cart' : 'Sold out';
    setStatus(card, '');
  }

  function setStatus(card, text, isError) {
    const status = card.querySelector('[data-status]');
    if (!status) return;
    status.textContent = text;
    status.classList.toggle('is-error', !!isError);
  }

  function refreshBubble(sections) {
    const html = sections && sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (fresh) bubble.innerHTML = fresh.innerHTML;
  }

  function showBar(page, label, count) {
    const bar = page.querySelector('[data-bar]');
    if (!bar) return;
    bar.querySelector('[data-bar-msg]').textContent = `Added: ${label}.`;
    bar.querySelector('[data-bar-count]').textContent = count;
    bar.hidden = false;
  }

  async function add(page, card) {
    const pack = selected(card);
    const button = card.querySelector('[data-add]');
    if (!pack || button.disabled) return;

    const cap = window.NRQtyCap;
    if (cap && cap.allows && !(await cap.allows(pack.dataset.sku, 1))) {
      setStatus(card, `Single 8" planters are limited to ${cap.max} per order. The 4-pack is the better deal.`, true);
      return;
    }

    button.disabled = true;
    setStatus(card, 'Adding…');
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(pack.dataset.variant), quantity: 1 }], sections: 'cart-icon-bubble' }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Could not add that to your cart.');

      refreshBubble(data.sections);
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      showBar(page, pack.dataset.label, cart.item_count);
      setStatus(card, 'Added to your cart.');
      button.classList.add('is-added');
      button.querySelector('[data-add-label]').textContent = 'Added. Add another?';
    } catch (error) {
      setStatus(card, error.message, true);
    } finally {
      button.disabled = pack.dataset.available !== 'true';
    }
  }

  function init(page) {
    page.querySelectorAll('[data-card]').forEach((card) => {
      card.querySelectorAll('.nrcl-pack').forEach((pack) => pack.addEventListener('click', () => select(card, pack)));
      const addButton = card.querySelector('[data-add]');
      if (addButton) addButton.addEventListener('click', () => add(page, card));
      const first = selected(card);
      if (first) select(card, first);
    });

    // Arrow keys move between packs, like a real radio group.
    page.addEventListener('keydown', (event) => {
      const pack = event.target.closest && event.target.closest('.nrcl-pack');
      if (!pack || !['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const packs = [...pack.parentElement.querySelectorAll('.nrcl-pack:not([aria-disabled="true"])')];
      const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      const next = packs[(packs.indexOf(pack) + step + packs.length) % packs.length];
      if (next) {
        event.preventDefault();
        next.focus();
        next.click();
      }
    });

    // Smooth scroll for the banner hotspot, chips and closing button.
    page.addEventListener('click', (event) => {
      const link = event.target.closest && event.target.closest('a[href^="#nrcl-"]');
      if (!link) return;
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    });
  }

  document.querySelectorAll('.nrcl').forEach(init);
})();
